import React, { useState } from 'react';
import { createAgent } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Buttons.css';
import './_Input.css';

const CreateAgentModal = ({ onClose, onAgentCreated }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [contact_name, setContact_name] = useState('');
    const [description, setDescription] = useState('');
    const [agreement_start_date, setAgreement_start_date] = useState('');
    const [agreement_end_date, setAgreement_end_date] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        const payload = {
            name,
            contact_name,
            agreement_start_date,
            email: email,
            phone: phone,
        };

        if (description) {
            payload.description = description;
        }
        if (agreement_end_date) {
            payload.agreement_end_date = agreement_end_date;
        }

        try {
            await createAgent(payload);
            setSuccess('Agent created successfully!');
            setName('');
            setEmail('');
            setPhone('');
            setContact_name('');
            setDescription('');
            setAgreement_start_date('');
            setAgreement_end_date('');
            onAgentCreated();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Create New Agent</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            id="name"
                            type="text"
                            placeholder="Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            id="email"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            id="phone"
                            type="text"
                            placeholder="Phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            id="contact_name"
                            type="text"
                            placeholder="Contact Name"
                            value={contact_name}
                            onChange={(e) => setContact_name(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            id="description"
                            placeholder="Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="agreement_start_date">Agreement Start Date</label>
                        <input
                            id="agreement_start_date"
                            type="date"
                            placeholder="Agreement Start Date"
                            value={agreement_start_date}
                            onChange={(e) => setAgreement_start_date(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="agreement_end_date">Agreement End Date</label>
                        <input
                            id="agreement_end_date"
                            type="date"
                            placeholder="Agreement End Date"
                            value={agreement_end_date}
                            onChange={(e) => setAgreement_end_date(e.target.value)}
                        />
                    </div>
                    {success && <p className="success">{success}</p>}
                    <div className='actions-centered'>
                        <button onClick={onClose} className='cancel-button text-button'>Cancel</button>
                        <button type="submit" className='submit-button text-button'>Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateAgentModal;